import axios from "axios";
import { baseURL } from "config";

async function getChatFilters(params: any) {
  const res = await axios.get(`${baseURL}/admin/chat-filters`, { params });
  return res.data;
}

export default getChatFilters;
